import { createApi } from '@reduxjs/toolkit/query/react'
import getQuery from '../../helpers/api/get-query'
import Team from '../../types/api/team'
import Strapi, { EndpointQueryParameters } from '../../types/strapi/strapi'
import getCustomFetchBase from '../custom-fetch-base'

export const teamsApi = createApi({
    reducerPath: 'teamsApi',
    baseQuery: getCustomFetchBase({ baseUrl: import.meta.env.VITE_API_URL }),
    tagTypes: ['Teams'],
    endpoints: builder => ({
        getTeams: builder.query<Strapi<Team>, EndpointQueryParameters | void>({
            query: getQuery('/teams'),
            providesTags: ['Teams'],
        }),
    }),
})

export const { useGetTeamsQuery } = teamsApi
